import type { AppsColumnListConfig } from "app/pages/sales-intelligence/modules/apps-search/types/table";
import { androidTableColumnConfig } from "app/pages/sales-intelligence/pages/find-apps/configuration/columns/androidColumnConfig";
import { iosTableColumnConfig } from "app/pages/sales-intelligence/pages/find-apps/configuration/columns/iosColumnConfig";
import { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";
import type {
    FindAppsRowDto,
    IFindAppsAndroidRowDto,
    IFindAppsIosRowDto,
} from "app/pages/sales-intelligence/store/find-apps/types/dto";

const COLUMN_CONFIG: Record<
    AppsSourceType,
    AppsColumnListConfig<IFindAppsAndroidRowDto> | AppsColumnListConfig<IFindAppsIosRowDto>
> = {
    [AppsSourceType.GoogleStore]: androidTableColumnConfig,
    [AppsSourceType.AppleStore]: iosTableColumnConfig,
};

export const getColumnConfig = (appSourceType: AppsSourceType): AppsColumnListConfig<FindAppsRowDto> =>
    COLUMN_CONFIG[appSourceType] as AppsColumnListConfig<FindAppsRowDto>;
